document.addEventListener("keydown", (event) => {
  if (event.key === "Tab") {
    document.documentElement.dataset.keyboardFocus = "";
  }
});

document.addEventListener("pointerdown", () => {
  delete document.documentElement.dataset.keyboardFocus;
});
